/**
 * Testimonials Section - Swiper Slider
 */

document.addEventListener('DOMContentLoaded', function () {
  const testimonialsSlider = document.querySelector(
    '[data-testimonials-slider]',
  );

  if (testimonialsSlider && typeof Swiper !== 'undefined') {
    new Swiper(testimonialsSlider, {
      slidesPerView: 'auto',
      spaceBetween: 32,
      grabCursor: true,
      loop: false,
      freeMode: {
        enabled: true,
        sticky: true
      },
      breakpoints: {
        // Mobile (below 768px)
        0: {
          slidesPerView: 1.20,
          spaceBetween: 20,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
        // Tablet and Desktop (768px and up)
        768: {
          spaceBetween: 32,
          slidesPerView: 1.55,
          slidesOffsetBefore: 52,
          slidesOffsetAfter: 52,
          watchOverflow: true
        },
        1040: {
          spaceBetween: 32,
          slidesPerView: 2.35,
          slidesOffsetBefore: 52,
          slidesOffsetAfter: 52,
          watchOverflow: true
        },
        1280: {
          spaceBetween: 32,
          slidesPerView: 2.82,
          slidesOffsetBefore: 52,
          slidesOffsetAfter: 52,
        },

      },
    });
  }
});
